<template>
    <el-container class="operation-management-container">
         <el-header>
                <header-common>
                </header-common>
            </el-header>
        <el-aside>
            <div class="aside-menu-container">
                <aside-menu/>
            </div>
        </el-aside>
            <el-main>
                <bread-crumb></bread-crumb>
                <router-view/>
            </el-main>
    </el-container>
</template>
<script>
import AsideMenu from './Menu';
import HeaderCommon from './HeaderCommon.vue';
import BreadCrumb from './BreadCrumb.vue';

export default {
    components: {
        AsideMenu,
        HeaderCommon,
        BreadCrumb
    }
};
</script>
<style lang="less" scoped>
    @media screen and (min-width: 0px) and (max-width:720px){
        .el-aside {
            background-color: #1a244d;
            text-align: center;
            width: 240px !important;
            position: absolute;
            z-index: 200;
            height: calc(100% - 50px);
            margin-top: 50px;
            display: none;
            .aside-logo-container {
                line-height: 64px;
                color: #f3f6ff;
                font-size: 15px;

                img {
                    width: 54px;
                    height: 21px;
                    vertical-align: text-bottom;
                    margin-left: 5px;
                }
            }
        }
.operation-management-container {
        height: 100%;

        .el-aside {
            background-color: #1a244d;
            text-align: center;
            width: 240px !important;
            position: fixed;
            z-index: 200;
            height: calc(100% - 50px);
            margin-top: 50px;
            .aside-logo-container {
                line-height: 64px;
                color: #f3f6ff;
                font-size: 15px;

                img {
                    width: 54px;
                    height: 21px;
                    vertical-align: text-bottom;
                    margin-left: 5px;
                }
            }
        }

        .t_img{
            width: 53px;
            height: 0px;
            float: left;
            margin-top: 3px;
            margin-right: 30px ;
            }

        .el-header {
            background: #1a244d;
            color: #424d55;
            height: 55px !important;
            padding: 0 32px 0 18px;
            z-index: 100;
            min-width: 1200px;
        }

        .el-main {
            background-color: #e9eef3;
            color: #333;
            padding: 0.2rem;
            position: relative;
            min-width: 1200px;
            // width: calc(100% - 240px);
            // margin-left: 240px;
            height: calc(100% - 50px);
            z-index: 100;
        }

        body > .el-container {
            margin-bottom: 40px;


        }

        .el-container:nth-child(5) .el-aside,
        .el-container:nth-child(6) .el-aside {
            line-height: 260px;
        }

        .el-container:nth-child(7) .el-aside {
            line-height: 320px;
        }
    }



    }
    @media screen and (min-width: 721px) and (max-width:3920px){
.el-aside {
            background-color: #1a244d;
            text-align: center;
            width: 240px !important;
            position: fixed;
            z-index: 200;
            height: calc(100% - 50px);
            margin-top: 50px;
            .aside-logo-container {
                line-height: 64px;
                color: #f3f6ff;
                font-size: 15px;

                img {
                    width: 54px;
                    height: 21px;
                    vertical-align: text-bottom;
                    margin-left: 5px;
                }
            }
        }
.operation-management-container {
        height: 100%;

        .el-aside {
            background-color: #1a244d;
            text-align: center;
            width: 240px !important;
            position: fixed;
            z-index: 200;
            height: calc(100% - 50px);
            margin-top: 50px;
            .aside-logo-container {
                line-height: 64px;
                color: #f3f6ff;
                font-size: 15px;

                img {
                    width: 54px;
                    height: 21px;
                    vertical-align: text-bottom;
                    margin-left: 5px;
                }
            }
        }

        .t_img{
            width: 53px;
            height: 0px;
            float: left;
            margin-top: 3px;
            margin-right: 30px ;
            }

        .el-header {
            background: #1a244d;
            color: #424d55;
            height: 55px !important;
            padding: 0 32px 0 18px;
            // min-width: 1200px;
            width: 100%;
            position: fixed;
            z-index: 100;
        }

        .el-main {
            background-color: #e9eef3;
            color: #333;
            padding: 0.2rem;
            // position: relative;
            width: calc(100% - 240px);
            margin-left: 240px;
            min-width: 1200px;
            position: absolute;
            z-index: 100;
            margin-top: 50px;
            height: calc(100% - 50px);
            // z-index: -1;
        }

        body > .el-container {
            margin-bottom: 40px;


        }

        .el-container:nth-child(5) .el-aside,
        .el-container:nth-child(6) .el-aside {
            line-height: 260px;
        }

        .el-container:nth-child(7) .el-aside {
            line-height: 320px;
        }
    }
    }

</style>
